import styled from 'styled-components';

import StyledDefaultVariant from './StyledDefaultVariant';

export default styled(StyledDefaultVariant)`
	gap: var(--spacing-small);
	.motif-badge {
		flex-shrink: 0;
	}
`;
